export const env = {
  lambdaApiUrl: import.meta.env.VITE_APP_API_URL ?? "",
  nestApiUrl: import.meta.env.VITE_NEST_API_URL ?? "",
  contactPage: import.meta.env.VITE_CONTACT_URL ?? "",
  universalLinkScheme: import.meta.env.VITE_UNIVERSAL_LINK_SCHEME ?? "",
  posthogKey: import.meta.env.VITE_POSTHOG_KEY ?? "",
  posthogHost: import.meta.env.VITE_POSTHOG_HOST ?? "",
  cartoBasemapApiKey: import.meta.env.VITE_CARTO_BASEMAP_API_KEY ?? "",
};
